import React from 'react';

import Button from 'antd/es/button';
import MainModal from '../MainPage/MainModal';
import { US_LAWNS_HUBSPOT } from '../Constants/Urls';

export const USLawnsRestrictModal = ({ modalVisible, setModalVisible, mobileView }: $TSFixMe) => {
  return (
    <MainModal
      width={mobileView ? 350 : 600}
      title='Please contact your Franchisee admin or US Lawns home office.'
      maskClosable
      closable={false}
      onCancel={() => setModalVisible(false)}
      visible={modalVisible}>
      <>
        <p className='mt-lg font-15'>
          You might already have a pro access to Attentive’s automated takeoffs. Please check with your Franchisee admin
          or US Lawns headquarters. They will send you an email invite to quickly get you started.
        </p>
        <p className='mt-2 font-15'>Please reach out to us for more support on this.</p>
        <div className='mt-lg text-center'>
          <Button ghost className='mr' type='primary' size='small' onClick={() => setModalVisible(false)}>
            Go back
          </Button>
          <Button type='primary' className='ml' size='small' onClick={() => window.open(US_LAWNS_HUBSPOT)}>
            Contact Us
          </Button>
        </div>
      </>
    </MainModal>
  );
};
